// extracted by mini-css-extract-plugin
export default {"checkbox":"ExtraItem_checkbox__aT21A","priceLabel":"ExtraItem_priceLabel__MOaZw"};